import React, { useState } from "react";
import { Dialog } from "@mui/material";
import ConsolidatedFeeDetails from "./ConsolidatedFeeDetails";
import StudentFeeSummary from "./StudentFeeSummary";
import { StudentFeeSummaryWithoutAccordion } from "./StudentFeeSummary";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";

import FeeBreakupSummary from "./FeeBreakupSummary";
import { useFetchPaymentDetails, useInstallmentwiseReceipt } from "./service";
import ALoader from "../../../common/a-loader";
import AdvancePaymentDetails from "./advancePaymentDetails/AdvancePaymentDetails";
import StudentBankDetails from "./studentBankDetails";

const PaymentSummary = ({ currentApplicationDetails, source }) => {
  const [feeSummaryDialog, setFeeSummaryDialog] = useState({
    isOpen: false,
    data: null,
  });
  const [paymentDetails, isLoading] = useFetchPaymentDetails(
    currentApplicationDetails
  );

  const openSummaryDialog = (data) => {
    setFeeSummaryDialog({ isOpen: true, data });
  };
  
  const [installmentwiseReceiptMapping, isLoader] = useInstallmentwiseReceipt(
    currentApplicationDetails,
  );

  return (
    <div>
      {(isLoading|| isLoader) && <ALoader position="fixed" />}
      <ConsolidatedFeeDetails paymentDetails={paymentDetails} />
      <StudentFeeSummary
        paymentDetails={paymentDetails}
        openSummaryDialog={openSummaryDialog}
      />
      <FeeBreakupSummary
        setFeeSummaryDialog={setFeeSummaryDialog}
        feeSummaryDialog={feeSummaryDialog}
        currentApplicationDetails={currentApplicationDetails}
        installmentwiseReceiptMapping={installmentwiseReceiptMapping}
      />
      <AdvancePaymentDetails currentApplicationDetails={currentApplicationDetails}/>

      <StudentBankDetails source={source}/>
    </div>
  );
};

export const FeeBreakupSummaryForCharges = ({ currentApplicationDetails }) => {
  const [openDialog, setOpenDialog] = useState(false);
  // this for summary for each installMent
  const [feeSummaryDialog, setFeeSummaryDialog] = useState({
    isOpen: false,
    data: null,
  });
  const [paymentDetails, isLoading] = useFetchPaymentDetails(
    currentApplicationDetails
  );
  const [installmentwiseReceiptMapping, isLoader] = useInstallmentwiseReceipt(
    currentApplicationDetails,
  );
  const openDialogHandler = (flag) => {
    setOpenDialog(flag);
  };

  const openSummaryDialog = (data) => {
    setFeeSummaryDialog({ isOpen: true, data });
  };

  if (!openDialog)
    return (
      <span className="hide-btn" onClick={() => openDialogHandler(true)}>
        View full summary
      </span>
    );
  return (
    <>
      <Dialog
        maxWidth="lg"
        onClose={() => setOpenDialog(false)}
        open={openDialog}
      >
        <div className="p-2">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="color-dark heading-4"> Full preview of summary</div>
            <IconButtonWrapper onClick={() => openDialogHandler(false)}>
              <CrossIcon width={30} height={30} />
            </IconButtonWrapper>
          </div>
          <StudentFeeSummaryWithoutAccordion
            paymentDetails={paymentDetails}
            openSummaryDialog={openSummaryDialog}
          />
          <FeeBreakupSummary
            setFeeSummaryDialog={setFeeSummaryDialog}
            feeSummaryDialog={feeSummaryDialog}
            currentApplicationDetails={currentApplicationDetails}
            installmentwiseReceiptMapping={installmentwiseReceiptMapping}
          />
        </div>
      </Dialog>
    </>
  );
};

export default PaymentSummary;
